export default function ReportViewerTemplate(data) {
    //language=HTML
    return `
        <div class="tabs k-content n-text-right">
            <div class=" info ">
                <div class="container-fluid">
                    <div class="details toolbar px-md-4 px-0">

                        <div class="row quick-icons justify-content-center justify-content-md-between align-items-center position-relative pt-2 w-100 m-0">
                            <div class="col-xl-5 col-md-8 col-12 px-md-0 mb-2 mb-md-0">
                                <ul class=" navbar-nav flex-row px-0 overflow-auto pb-2 justify-content-center justify-content-md-start report-icons">
                                    <li><a id="reportZoomIn" role="button" class=" text-secondary"><i
                                            class="fa-solid fa-magnifying-glass-plus"></i></a></li>
                                    <li><a id="reportZoomOut" role="button" class=" text-secondary"><i class="fa-solid fa-magnifying-glass-minus"></i></a>
                                    </li>
                                    <li><a id="reportRelaunch" role="button" class=" text-secondary"><i class="fa-solid fa-rotate-right"></i></a></li>
                                    <li><a id="print" role="button" class=" text-secondary"><i class="fa-solid fa-print"></i></a></li>
                                    <li><a id="export" role="button" class="btn-printing text-secondary">
                                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 150 150">
                                            <g>
                                                <path fill="currentColor" class="st0" d="M150.1,103.3c0,5.4-4,9.4-9.5,9.4c-6.1,0-12.3,0-18.6,0c0,0.6,0,1.1,0,1.6c0,8.8,0,17.6,0,26.4
                                                    c0,5.5-4,9.5-9.5,9.5c-24.9,0-49.8,0-74.7,0c-5.5,0-9.5-4-9.5-9.5c0-8.9,0-17.8,0-26.7c0-0.4,0-0.8,0-1.4c-6.3,0-12.5,0-18.6,0
                                                    c-4.7,0-8.4-2.9-9.4-7.5c-0.1-0.6-0.2-1.3-0.2-1.9c0-18.7,0-37.4,0-56.1c0-5.6,4-9.6,9.6-9.6c43.7,0,87.4,0,131.1,0
                                                    c5.2,0,9.3,4.1,9.3,9.2C150.1,65.7,150.1,84.5,150.1,103.3z M112.5,84.6c-24.9,0-49.8,0-74.7,0c0,18.7,0,37.4,0,56
                                                    c25,0,49.8,0,74.7,0C112.5,121.9,112.5,103.3,112.5,84.6z M131.4,47.1c-5.2,0-9.4,4.2-9.4,9.4c0,5,4.2,9.2,9.2,9.3
                                                    c5.2,0,9.4-4.1,9.5-9.3C140.7,51.3,136.5,47.1,131.4,47.1z M70,90.8c3.1,0,6.1,0,9.2,0c0,7.2,0,12.7,0,17.8c5.1,0,10.6,0,17.8,0
                                                    c0,3.1,0,6.1,0,9.2c-7.2,0-12.7,0-17.8,0c0,5.1,0,10.6,0,17.8c-3.1,0-6.1,0-9.2,0c0-7.2,0-12.7,0-17.8c-5.1,0-10.6,0-17.8,0
                                                    c0-3.1,0-6.1,0-9.2c7.2,0,12.7,0,17.8,0C70,103.5,70,98,70,90.8z M112.6,28.2c0-6.2,0-12.4,0-18.6c-25,0-49.9,0-74.9,0
                                                    c0,6.2,0,12.3,0,18.6c-3.2,0-6.2,0-9.4,0c0-0.4-0.1-0.8-0.1-1.3c0-5.8,0-11.7,0-17.6c0-5.1,4.1-9.2,9.2-9.2c25.1,0,50.2,0,75.3,0
                                                    c5.2,0,9.2,4.1,9.2,9.3c0,6.2,0,12.4,0,18.7C118.8,28.2,115.8,28.2,112.6,28.2z"/>
                                            </g>
                                        </svg>
                                    </a>
                                    </li>
                                    <li><a id="sendEmailWithResult" role="button" class=" text-secondary"><i
                                            class="fa-solid fa-envelope-open-text"></i></a>
                                    </li>
                                </ul>

                            </div>
                            <div class="col-xl-7 col-md-4 col-12 ml-4 ml-md-0 px-md-0">
                                <div id="pager" class=" bg-transparent border-0 pb-2 justify-content-center justify-content-md-end"></div>
                            </div>

                        </div>

                        <div>
                            <iframe id="reportIFrame" style="width: 100%; border: 1px solid var(--light);"></iframe>
                        </div>

                    </div>
                </div>
            </div>
        </div>`;
}